import TForm from "../../Form/TForm";
import Interface from "../../Interface";
import MemberRequest from "../../../../app/Controllers/MemberRequest";


const sendDataExcelApi =   function (baseUrl,excelUrl,queryFields,queryArgs,pageAlerts,objTable,filters,callback) {
  let req=new MemberRequest();
  req._pageAlerts=pageAlerts;
  let params={};
  req._hasParams=true;
  if(!Interface.isEmptyString(filters)){
      let myobj = JSON.parse(filters); 
      Object.assign(params,myobj);  
  }
  req.params=params;
  if( queryArgs === undefined || queryArgs === null) queryArgs="";
  req._url= baseUrl+excelUrl;
  let fd=TForm.objectToFormData(objTable);
  req.sendPost(callback,fd);
};

export default   function DataExcelApi(baseUrl,excelUrl,queryFields,queryArgs,pageAlerts,objTable={start:0, length:10, order_column:0,
  order_dir:1,current_page:1 },filters="",callback=null) {
  sendDataExcelApi(baseUrl,excelUrl,queryFields,queryArgs,pageAlerts,objTable,filters,callback);
}
